<template>
  <AGButton
    :id="id"
    icon-size="22px"
    left-icon="mdi-download-outline"
    type="secondary"
    :disabled="disabled"
    :loading="loading"
    @click="onClickEmit"
  >
    Exportar
    <slot name="append-inner" />
  </AGButton>
</template>

<script>
import AGButton from '@/components/common/AGButton.vue';
import { uniqueId } from 'lodash';

export default {
  emits: ['click'],
  components: {
    AGButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: uniqueId('btn_export_'),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickEmit(e) {
      this.$emit('click', e);
    },
  },
};
</script>
